/**
 * External links shown across the app. Single source of truth so a URL can't
 * drift between the login page and the shared auth shell (it did once: the
 * netlify rebrand-preview link lingered on the forgot-password / invite pages
 * after the login page had moved to the canonical domain).
 */

/** Public privacy policy on the canonical marketing domain. */
export const PRIVACY_URL = "https://trustcareaustralia.com.au/privacy/";
